import React from 'react';
import AntdSelect from './AntdSelect';

const TSSelect = (props) => {

    const {isFromAntd = true} = props;

  return (
    <>
        {isFromAntd && <AntdSelect {...props}/>}
    </>
  );
};

export default TSSelect;